import moment from 'moment'
import store from '@/store'

export type FormatNumberMethod = (number: any, options?: Intl.NumberFormatOptions) => string
export type FormatPriceMethod = (number: any) => string
export type FormatDistanceMethod = (number: any) => string

export const getPhonePrefix = (onlyNumber: boolean = false) => {
  // const store = useStore()
  const isSerbiaMode = store.getters['globalSettings/isSerbiaMode']()
  const symbol = onlyNumber ? '' : '+'

  return symbol + (isSerbiaMode ? '381' : '7')
}

export const getPhoneMaskPlaceholder = () => {
  const prefix = getPhonePrefix()
  return `${prefix} (xxx) xxx-xx-xx`
}

export const getPhoneMask = () => {
  const prefix = getPhonePrefix()
  return `${prefix} (###) ###-##-##`
}

export const formatNumber: FormatNumberMethod = (number, options) => {
  if (typeof number === 'string') {
    number = Number(number)
  }

  let result = new Intl.NumberFormat('ru-RU', options).format(number?.toFixed(2)) || '0'
  if (result === '-0') return '0'

  // Чтобы число переносилось по пробелам в тесных контейнерах,
  // удаляет специальный символ неразрывного пробела
  result = result.replace(/\u00A0/g, ' ')

  return result
}

export const formatPrice: FormatPriceMethod = (number) => {
  const num = formatNumber(number ?? 0, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
  const isSerbiaMode = store.getters['globalSettings/isSerbiaMode']()
  const symbol = isSerbiaMode ? 'din' : '₽'

  return `${num} ${symbol}`
}

type DateFormatOptions = {
  isDate?: boolean
  isTime?: boolean
  isSeconds?: boolean
  useTimeZoneFromSettings?: boolean
}

export const formatDate = (value?: Date | string, options: DateFormatOptions = {}): string => {
  try {
    if (!value) return ''

    const timeZone = store.getters['globalSettings/getTimeZone']()

    const { isDate = true, isTime = false, isSeconds = false } = options
    const format = [
      (isDate ?? true) ? 'DD-MM-YYYY' : '',
      isTime && !isSeconds ? 'HH:mm' : '',
      isTime && isSeconds ? 'HH:mm:ss' : '',
    ]
      .join(' ')
      .trim()
    const date = moment(value).parseZone()

    if (options.useTimeZoneFromSettings ?? true) {
      date.tz(timeZone)
    }

    return date.format(format)
  } catch (err) {
    return ''
  }
}

export const formatDistance: FormatDistanceMethod = (distance) => {
  return `${formatNumber(distance)} км`
}

export const substringText = (text: string, length?: number): string => {
  const requiredLength = length ?? 30
  const textLength = text.length ?? 0
  const message = text.substring(0, requiredLength)

  return `${message} ${textLength > requiredLength ? '...' : ''}`
}

export const formatPhone = (phone: string): string => {
  let newPhone = phone.replace(/\D/g, '')

  let prefix = newPhone.slice(0, -10)
  if (!prefix) prefix = '7'

  if (newPhone.length > 10) newPhone = newPhone.slice(-10, newPhone.length)

  return newPhone.replace(/(\d{3})(\d{3})(\d{2})(\d{2})/, `+${prefix} ($1) $2-$3-$4`)
}

// Говнокод от которого нужно избавиться
export const formatObjectToString = (object: any): string => {
  // FROM => [{ "3500": [40,40,true] }, { "4500": [42,42,true] }, { "5500": [43,43,true] }]
  // TO => {3500:[40,40,True]} {4500:[42,42,True]} {5500:[43,43,True]}

  let string = JSON.stringify(object)

  string = string.replace(/},/g, '} ')
  string = string.replace(/"/g, "'")
  string = string.replace(/'(-?[0-9]+\.{0,1}[0-9]*)'/g, '$1')
  string = string.replace(/true/g, 'True')
  string = string.replace(/false/g, 'False')
  string = string.replace(/^\[/, '')
  string = string.replace(/\]$/, '')

  return string
}

export const formatFullName = (data: {
  firstName?: string
  middleName?: string
  lastName?: string
}) => {
  return [data.lastName, data.firstName, data.middleName].filter((e) => e).join(' ')
}

export default {
  getPhonePrefix,
  getPhoneMaskPlaceholder,
  getPhoneMask,
  formatNumber,
  formatPrice,
  formatDate,
  formatDistance,
  substringText,
  formatPhone,
  formatObjectToString,
  formatFullName,
}
